// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BasicTomSelectController from "./basic_tom_select_controller"
application.register("basic-tom-select", BasicTomSelectController)

import AbRulesController from "./ab_rules_controller"
application.register("ab-rules", AbRulesController)

import CampaignFormController from "./campaign_form_controller"
application.register("campaign-form", CampaignFormController)

import CampaignValidationController from "./campaign_validation_controller"
application.register("campaign-validation", CampaignValidationController)

import CampaignUnlockController from "./campaign_unlock_controller"
application.register("campaign-unlock", CampaignUnlockController)

import CountryFieldsController from "./country_fields_controller"
application.register("country-fields", CountryFieldsController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DaySelectorController from "./day_selector_controller"
application.register("day-selector", DaySelectorController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExperiencePreviewController from "./experience_preview_controller"
application.register("experience-preview", ExperiencePreviewController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import VerifyRulesController from "./verify_rules_controller"
application.register("verify-rules", VerifyRulesController)

import GeoKindController from "./geo_kind_controller"
application.register("geo-kind", GeoKindController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IntegrationFormController from "./integration_form_controller"
application.register("integration-form", IntegrationFormController)

import IntegrationSecretController from "./integration_secret_controller"
application.register("integration-secret", IntegrationSecretController)

import LocationSelectorController from "./location_selector_controller"
application.register("location-selector", LocationSelectorController)

import LogoController from "./logo_controller"
application.register("logo", LogoController)

import MerchantLogoUploadController from "./merchant_logo_upload_controller"
application.register("merchant-logo-upload", MerchantLogoUploadController)

import MultipleSelectController from "./multiple_select_controller"
application.register("multiple-select", MultipleSelectController)

import PreviewImageController from "./preview_image_controller"
application.register("preview-image", PreviewImageController)

import QrConfigController from "./qr_config_controller"
application.register("qr-config", QrConfigController)

import RoleBasedFieldsController from "./role_based_fields_controller"
application.register("role-based-fields", RoleBasedFieldsController)

import RoleBasedAdminFieldsController from "./role_based_fields_admin_controller"
application.register("role-based-fields-admin", RoleBasedAdminFieldsController)

import RulesController from "./rules_controller"
application.register("rules", RulesController)

import SaveWhenDirtyController from "./save_when_dirty_controller"
application.register("save-when-dirty", SaveWhenDirtyController)

import TableEditController from "./table_edit_controller"
application.register("table-edit", TableEditController)

import TextController from "./text_controller"
application.register("text", TextController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TurboPreviewController from "./turbo_preview_controller"
application.register("turbo-preview", TurboPreviewController)

import VisibilityTimeRangeController from "./visibility_time_range_controller"
application.register("visibility-time-range", VisibilityTimeRangeController)
